<template>
  <div>
    <router-view />
    <!-- 1111 -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  metaInfo: {
    title: "WESERVE LIFESTYLE : บริการสั่งอาหาร สินค้า & ส่งของ เมสเซนเจอร์",
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "keywords",
        content:
          "weserve, Food Delivery, Delivery Phuket, Delivery Trang, Delivery Suratthani, Delivery Krabi, สั่งอาหารออนไลน์ภูเก็ต, สั่งอาหารออนไลน์ตรัง, สั่งอาหารออนไลน์สุราษฎร์ธานี, สั่งอาหารออนไลน์กระบี่, สั่งสินค้าออนไลน์,แมสเซนเจอร์ ภูเก็ต, แมสเซนเจอร์ ตรัง, แมสเซนเจอร์ สุราษฎร์ธานี, แมสเซนเจอร์ กระบี่",
      },
      {
        name: "description",
        content:
          "วีเสิร์ฟพร้อมส่งให้ในแอปเดียว สะดวก ปลอดภัย ส่งตรงถึงมือคุณ อยากได้อะไร สั่งเลย!",
      },
      {
        property: "og:title",
        content:
          "สั่งอาหาร สินค้าออนไลน์ & บริการแมสเซนเจอร์ | WESERVE LIFESTYLE",
      },
      { property: "og:type", content: "website" },
      {
        name: "robots",
        content:
          "weserve, Food Delivery, Delivery Phuket, Delivery Trang, Delivery Suratthani, Delivery Krabi, สั่งอาหารออนไลน์ภูเก็ต, สั่งอาหารออนไลน์ตรัง, สั่งอาหารออนไลน์สุราษฎร์ธานี, สั่งอาหารออนไลน์กระบี่, สั่งสินค้าออนไลน์,แมสเซนเจอร์ ภูเก็ต, แมสเซนเจอร์ ตรัง, แมสเซนเจอร์ สุราษฎร์ธานี, แมสเซนเจอร์ กระบี่",
      },
      { name: "og:url", content: "https://weserve.co.th" },
    ],
  },
};
</script>

<style>
input[type="number"] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.weserve-timepicker.time-picker .display-time {
  outline: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  border-top: none;
  border-left: none;
  border-right: none;
}

.weserve-timepicker.time-picker .display-time:hover {
  border-bottom: 1px solid #222222;
}

.weserve-timepicker.time-picker .display-time:focus {
  border-bottom: 1px solid #222222;
}
.time-picker .dropdown ul li.active,
.time-picker .dropdown ul li.active:hover {
  background: #ffd600 !important;
  color: black !important;
}

@font-face {
  font-family: "SukhumvitSet-Medium";
  src: url("./assets/font/SukhumvitSet-Medium.eot");
  src: url("./assets/font/SukhumvitSet-Medium.woff2") format("woff2"),
    url("./assets/font/SukhumvitSet-Medium.eot?") format("embedded-opentype")
      url("./assets/font/SukhumvitSet-Medium.woff") format("woff"),
    url("./assets/font/SukhumvitSet-Medium.ttf") format("truetype");
}
@font-face {
  font-family: "Kanit-Regular";
  src: url("./assets/font/Kanit-Regular.eot");
  src: url("./assets/font/Kanit-Regular.woff2") format("woff2"),
    url("./assets/font/Kanit-Regular.eot?") format("embedded-opentype"),
    url("./assets/font/Kanit-Regular.woff") format("woff"),
    url("./assets/font/Kanit-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "GoldenPlains";
  src: url("./assets/font/GoldenPlains.eot");
  src: url("./assets/font/GoldenPlains.woff2") format("woff2"),
    url("./assets/font/GoldenPlains.eot?") format("embedded-opentype"),
    url("./assets/font/GoldenPlains.woff") format("woff"),
    url("./assets/font/GoldenPlains.ttf") format("truetype");
}
* {
  font-family: "SukhumvitSet-Medium", "Kanit-Regular", sans-serif;
}

:root {
  --primaryColor: #fddf00;
}

.heading__5 {
  font-size: 20px;
  font-weight: bold;
}

.heading__4 {
  font-size: 22px;
  font-weight: bold;
}

.heading__3 {
  font-size: 24px;
  font-weight: bold;
}

.heading__2 {
  font-size: 26px;
  font-weight: bold;
}
.heading__1 {
  font-size: 28px;
  font-weight: bold;
}
</style>
